import {setStore} from 'assets/commonjs/storage';
import {getQueryString} from 'assets/commonjs/tool';


if(getQueryString("locale")){
  setStore('lang',getQueryString("locale"));
}
const staticRouter = [
  {
    path: '/',
    name: 'live',
    component:  () => import('@/views/live/index.vue'),
  },
 
  {
    path: '/myQuestion',
    name: 'myQuestion',
    component:  () => import('@/views/myQuestion/myQuestion.vue'),
  },
  {
    path: '/questionAnswer',
    name: 'questionAnswer',
    component:  () => import('@/views/questionAnswer/questionAnswer.vue'),
  },
  {
    path: '/questionDetail',
    name: 'questionDetail',
    component:  () => import('@/views/questionAnswer/questionDetail.vue'),
  },
  {
    path: '/chatDetail',
    name: 'chatDetail',
    component:  () => import('@/views/questionAnswer/chatDetail.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component:  () => import('@/views/login/login.vue'),
  },
  {
    path: '/chanceDetail/:id',
    name: 'chanceDetail',
    component:  () => import('@/views/tradeChance/chanceDetail.vue'),
  },
  {
    path: '/tradeChance',
    name: 'tradeChance',
    component:  () => import('@/views/tradeChance/tradeChance.vue'),
  },
  {
    path: '/analystDetail/:id',
    name: 'analystDetail',
    component:  () => import('@/views/tradeChance/analystDetail.vue'),
  },
  {
    path: '/app/chanceDetail/:id',
    name: 'chanceDetail',
    component:  () => import('@/views/app/chanceDetail.vue'),
  },
  {
    path: '/app/tradeChance',
    name: 'tradeChance',
    component:  () => import('@/views/app/tradeChance.vue'),
  },
  {
    path: '/app/analystDetail/:id',
    name: 'analystDetail',
    component:  () => import('@/views/app/analystDetail.vue'),
  },
  {
    path: '/ask',
    name: 'ask',
    component:  () => import('@/views/questionAnswer/ask.vue'),
  },
  {
    path: '/videoRoom',
    name: 'videoRoom',
    component:  () => import('@/views/videoRoom/video.vue'),
  },
  {
    path: '/changeNick',
    name: 'changeNick',
    component:  () => import('@/views/changeNickName/changeNick.vue'),
  },
  {
    path: '/test',
    name: 'test',
    component:  () => import('@/views/chat/load.vue'),
  },
  
  
  
];

export default staticRouter;
